/* What the shopper sees after an add to cart.
 *
 * The sticky add-to-cart bar belongs to a third-party app, and its answer to a
 * successful add is to rewrite its own button to "Aggiunto". On a phone that is
 * a black box wedged against the size chip, which reads more like a fault than
 * a confirmation. This puts a modal in front of it instead, and keeps the
 * header's cart count in step.
 *
 * Only the sticky bar's adds get the modal. The theme's own add-to-cart opens
 * the cart drawer, and two confirmations for one click is worse than the box.
 */
(function () {
  var STRINGS_ID = 'sks-cart-feedback-strings';
  var STICKY_BAR = '.zrx-sticky-atc-bar';
  var STICKY_CLICK_WINDOW_MS = 6000;

  var strings = readStrings();
  var lastStickyClickAt = 0;
  var modal = null;
  var lastFocused = null;
  var badgeCount = null;

  function readStrings() {
    var defaults = {
      added: 'Prodotto aggiunto',
      continue: 'Continua gli acquisti',
      checkout: 'Checkout',
      cart: 'Carrello',
      close: 'Chiudi',
      cartUrl: '/cart',
      currency: 'EUR',
      locale: 'it',
      moneyFormat: ''
    };

    try {
      var node = document.getElementById(STRINGS_ID);
      if (!node) return defaults;
      var parsed = JSON.parse(node.textContent || '{}');
      Object.keys(defaults).forEach(function (key) {
        if (parsed[key]) defaults[key] = String(parsed[key]);
      });
    } catch (e) {}

    return defaults;
  }

  // Shopify sends prices as an integer of the currency's minor unit — 25500 for
  // €255,00 — and never a formatted string, so the formatting is ours to do.
  //
  // It is done with the shop's own money format rather than with Intl, because
  // the two disagree: Intl writes "255,00 €" for Italian, and every other price
  // on this storefront reads "€255,00". A confirmation that spells the price
  // differently from the page behind it is a confirmation you look at twice.
  var MONEY_PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

  // This shop's money format is not a bare pattern: it is
  // `<span class=glc-money>€{{amount_with_comma_separator}}</span>`, the hook a
  // currency app hangs its conversions on. The modal wants the price as text,
  // so the markup comes out — escaped or not, since the format can arrive
  // either way depending on who serialised it.
  function cleanMoneyFormat(raw) {
    return String(raw || '')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&')
      .replace(/&nbsp;/g, '\u00a0')
      .replace(/<[^>]*>/g, '')
      .trim();
  }

  function groupDigits(cents, precision, thousands, decimal) {
    var amount = (Number(cents) / 100).toFixed(precision);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function formatMoney(cents) {
    if (cents === null || cents === undefined || !isFinite(Number(cents))) return '';

    var format = cleanMoneyFormat(strings.moneyFormat);
    var placeholder = format.match(MONEY_PLACEHOLDER);

    if (placeholder) {
      var value;
      switch (placeholder[1]) {
        case 'amount': value = groupDigits(cents, 2, ',', '.'); break;
        case 'amount_no_decimals': value = groupDigits(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': value = groupDigits(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = groupDigits(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = groupDigits(cents, 2, "'", '.'); break;
        case 'amount_with_space_separator': value = groupDigits(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = groupDigits(cents, 0, ' ', ','); break;
        case 'amount_with_period_and_space_separator': value = groupDigits(cents, 2, ' ', '.'); break;
        default: value = null;
      }

      if (value !== null) return format.replace(MONEY_PLACEHOLDER, value);
    }

    // No usable format string: the currency still has to be named, so fall back
    // rather than print a bare number.
    try {
      return new Intl.NumberFormat(strings.locale, {
        style: 'currency',
        currency: strings.currency
      }).format(Number(cents) / 100);
    } catch (e) {
      return groupDigits(cents, 2, '.', ',');
    }
  }

  /* ---------------------------------------------------------------- *
   * Header cart count                                                  *
   * ---------------------------------------------------------------- */

  function badges() {
    return Array.prototype.slice.call(document.querySelectorAll('cart-dot.header__cart-dot'));
  }

  function paintBadge(element, count) {
    var value = Math.max(0, parseInt(count, 10) || 0);
    var text = value > 99 ? '99+' : String(value);
    var slot = element.querySelector('.header__cart-count');

    if (!slot) {
      slot = document.createElement('span');
      slot.className = 'header__cart-count';
      slot.setAttribute('aria-hidden', 'true');
      element.appendChild(slot);
    }

    if (slot.textContent !== text) slot.textContent = text;
    element.setAttribute('data-cart-count', String(value));
    // The theme's own <cart-dot> toggles this class from its own fetch. Setting
    // it here as well keeps the two from disagreeing for a frame.
    element.classList.toggle('is-visible', value > 0);

    var link = element.closest('a');
    if (link) {
      link.setAttribute('aria-label', value > 0 ? strings.cart + ' (' + value + ')' : strings.cart);
    }
  }

  function setCount(count, options) {
    var value = Math.max(0, parseInt(count, 10) || 0);
    var changed = badgeCount !== null && badgeCount !== value;
    badgeCount = value;

    badges().forEach(function (element) {
      paintBadge(element, value);

      if ((changed || (options && options.bump)) && value > 0) {
        element.classList.remove('sks-cart-dot--bump');
        // Reading the layout is what lets the same animation run twice.
        void element.offsetWidth;
        element.classList.add('sks-cart-dot--bump');
      }
    });
  }

  var refreshing = false;

  function refreshCount(options) {
    if (refreshing) return Promise.resolve();
    refreshing = true;

    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') setCount(cart.item_count, options);
      })
      .catch(function () {})
      .then(function () { refreshing = false; });
  }

  function readInitialCount() {
    var element = badges()[0];
    if (!element) return;

    var raw = element.getAttribute('data-cart-count');
    if (raw === null || raw === '') {
      // No server-rendered number to start from, so ask, rather than flash a
      // badge that says nothing.
      refreshCount();
      return;
    }

    badgeCount = Math.max(0, parseInt(raw, 10) || 0);
    badges().forEach(function (node) { paintBadge(node, badgeCount); });
  }

  /* ---------------------------------------------------------------- *
   * The modal                                                          *
   * ---------------------------------------------------------------- */

  function buildModal() {
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'sks-added';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'sks-added-title');
    modal.hidden = true;
    modal.innerHTML = [
      '<div class="sks-added__panel">',
      '<button type="button" class="sks-added__close" data-close aria-label="', escapeHtml(strings.close), '">&times;</button>',
      '<svg class="sks-added__check" viewBox="0 0 60 60" aria-hidden="true">',
      '<circle cx="30" cy="30" r="26"/>',
      '<path d="M18 31.5 26.5 40 42 22"/>',
      '</svg>',
      '<p class="sks-added__title" id="sks-added-title">', escapeHtml(strings.added), '</p>',
      '<div class="sks-added__product" data-product></div>',
      '<div class="sks-added__actions">',
      '<button type="button" class="sks-added__btn sks-added__btn--ghost" data-close>', escapeHtml(strings.continue), '</button>',
      '<form class="sks-added__checkout" method="post" action="', escapeHtml(strings.cartUrl), '">',
      '<button type="submit" name="checkout" class="sks-added__btn sks-added__btn--solid">', escapeHtml(strings.checkout), '</button>',
      '</form>',
      '</div>',
      '</div>'
    ].join('');

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('[data-close]')) closeModal();
    });

    document.body.appendChild(modal);
    return modal;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function productMarkup(item) {
    if (!item || !item.title) return '';

    var image = item.image
      ? '<img class="sks-added__thumb" src="' + escapeHtml(item.image) + '" alt="" loading="lazy" width="56" height="56">'
      : '<span class="sks-added__thumb"></span>';

    var meta = [];
    if (item.variant) meta.push(item.variant);
    if (item.quantity && item.quantity > 1) meta.push('x' + item.quantity);

    var price = item.price ? formatMoney(item.price) : '';

    return image
      + '<div>'
      + (item.vendor ? '<div class="sks-added__brand">' + escapeHtml(item.vendor) + '</div>' : '')
      + '<div class="sks-added__name">' + escapeHtml(item.title) + '</div>'
      + (price ? '<div class="sks-added__price">' + escapeHtml(price) + '</div>' : '')
      + (meta.length ? '<div class="sks-added__meta">' + escapeHtml(meta.join(' · ')) + '</div>' : '')
      + '</div>';
  }

  function openModal(item) {
    var node = buildModal();
    node.querySelector('[data-product]').innerHTML = productMarkup(item);
    node.hidden = false;
    lastFocused = document.activeElement;

    // Two frames: one to take it out of `hidden`, one for the transition to
    // have a state to move away from.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        node.classList.add('is-open');
        var focusable = node.querySelector('.sks-added__btn');
        if (focusable) focusable.focus();
      });
    });

    document.addEventListener('keydown', onKeydown, true);
  }

  function closeModal() {
    if (!modal || modal.hidden) return;

    modal.classList.remove('is-open');
    document.removeEventListener('keydown', onKeydown, true);

    window.setTimeout(function () {
      if (modal && !modal.classList.contains('is-open')) modal.hidden = true;
    }, 220);

    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus(); } catch (e) {}
    }
    lastFocused = null;
  }

  function onKeydown(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.stopPropagation();
      closeModal();
      return;
    }

    if (event.key !== 'Tab' || !modal || modal.hidden) return;

    var focusable = modal.querySelectorAll('button, a[href]');
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ---------------------------------------------------------------- *
   * Catching the add                                                   *
   * ---------------------------------------------------------------- */

  function isCartAddUrl(url) {
    return /\/cart\/add(\.js|\.json)?(\?|$)/.test(String(url || '').split('#')[0]);
  }

  function cameFromStickyBar() {
    return Date.now() - lastStickyClickAt < STICKY_CLICK_WINDOW_MS;
  }

  // Shopify answers /cart/add.js with the line item, or with {items:[...]} for
  // a bundled add. Either way one product is enough for the modal.
  function itemFromResponse(payload) {
    if (!payload) return null;
    var line = Array.isArray(payload.items) ? payload.items[0] : payload;
    if (!line || !(line.product_title || line.title)) return null;

    var variant = line.variant_title && line.variant_title !== 'Default Title' ? line.variant_title : '';

    // `final_price` is the unit price after any line discount; `price` is what
    // it was before. The unit price is what the shopper is being shown, so a
    // discounted line says the discounted figure.
    var price = line.final_price;
    if (price === undefined || price === null) price = line.price;

    return {
      title: line.product_title || line.title,
      vendor: line.vendor || '',
      price: price,
      variant: variant,
      quantity: line.quantity || 1,
      image: line.image || line.featured_image || (line.featured_image && line.featured_image.url) || ''
    };
  }

  // What the bar itself is showing, for an add whose response never reached us.
  function itemFromStickyBar() {
    var bar = document.querySelector(STICKY_BAR);
    if (!bar) return null;

    var image = bar.querySelector('img');
    var title = document.querySelector('.product-title, h1');
    var vendor = document.querySelector('[data-product-vendor], .product-vendor, .vendor');

    return {
      title: title ? title.textContent.replace(/\s+/g, ' ').trim() : '',
      vendor: vendor ? vendor.textContent.replace(/\s+/g, ' ').trim() : '',
      price: null,
      variant: '',
      quantity: 1,
      image: image ? image.getAttribute('src') || '' : ''
    };
  }

  function confirmAdd(payload) {
    var item = itemFromResponse(payload) || itemFromStickyBar();
    openModal(item);
    refreshCount({ bump: true });
  }

  function watchFetch() {
    if (typeof window.fetch !== 'function') return;

    var original = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var watched = isCartAddUrl(url);

      return original.apply(this, arguments).then(function (response) {
        if (!watched || !response || !response.ok) return response;

        var sticky = cameFromStickyBar();
        // Reading the body consumes it, so the clone is what gets read and the
        // caller still gets an untouched response.
        try {
          response.clone().json().then(function (payload) {
            if (sticky) confirmAdd(payload);
            else refreshCount({ bump: true });
          }).catch(function () {
            if (sticky) confirmAdd(null);
            else refreshCount({ bump: true });
          });
        } catch (e) {
          if (sticky) confirmAdd(null);
        }

        return response;
      });
    };
  }

  function watchXhr() {
    if (typeof window.XMLHttpRequest !== 'function') return;

    var open = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__sksCartAdd = isCartAddUrl(url);
      return open.apply(this, arguments);
    };

    var send = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.send = function () {
      if (this.__sksCartAdd) {
        var xhr = this;
        var sticky = cameFromStickyBar();
        xhr.addEventListener('load', function () {
          if (xhr.status < 200 || xhr.status >= 300) return;

          var payload = null;
          try { payload = JSON.parse(xhr.responseText); } catch (e) {}

          if (sticky) confirmAdd(payload);
          else refreshCount({ bump: true });
        });
      }

      return send.apply(this, arguments);
    };
  }

  function watchStickyClicks() {
    ['pointerdown', 'click'].forEach(function (type) {
      document.addEventListener(type, function (event) {
        var target = event.target;
        if (target && target.closest && target.closest(STICKY_BAR)) {
          lastStickyClickAt = Date.now();
        }
      }, true);
    });
  }

  function watchThemeCartEvents() {
    ['cart:change', 'cart:refresh'].forEach(function (type) {
      document.addEventListener(type, function () { refreshCount({ bump: true }); });
    });
  }

  function start() {
    readInitialCount();
    watchStickyClicks();
    watchFetch();
    watchXhr();
    watchThemeCartEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
